import {NgModule} from '@angular/core';
import {MDMTooltipDirective} from './tooltip-directive';

@NgModule({
	declarations: [MDMTooltipDirective],
	exports: [MDMTooltipDirective],
})
export class DirectivesModule {}
